module.exports = __webpack_public_path__ + "img/tx-_0000s_0004_5.3e7ac8cb.png";